import React, { useEffect, useState } from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css"; // optional
import { FileUploader } from "react-drag-drop-files";
import { useFormik } from "formik";
import { toast } from "react-toastify";

const CollectionForm = ({
  nextHandler,
  submitBtnTxt,
}) => {

  const initialValues = {
    phrase: "",
  };

  const validate = values => {
    const errors = {};
    if (!values.phrase) {
      errors.phrase = "Required";
    }
    return errors;
  };
  const formik = useFormik({
    initialValues: initialValues,
    validate,
    onSubmit: (values, { resetForm }) => {
      nextHandler({ ...values });
      resetForm();
    },
  });
  return (
    <div>
      <>
        {/* <!--POET Phrase --> */}
        <div className="mb-6">
          <label
            htmlFor="item-name"
            className="font-display text-jacarta-700 mb-2 block dark:text-white"
          >
            POET Key<span className="text-red">*</span>
          </label>
          <input
            type="text"
            id="phrase"
            name="phrase"
            value={formik.values.phrase}
            className="dark:bg-jacarta-700 border-jacarta-100 hover:ring-accent/10 focus:ring-accent dark:border-jacarta-600 dark:placeholder:text-jacarta-300 w-full rounded-lg py-3 px-3 hover:ring-2 dark:text-white"
            placeholder="Enter POET Key"
            required
            onChange={formik.handleChange}
          />
          {formik.touched.phrase && formik.errors.phrase ? (
            <div className="error">{formik.errors.phrase}</div>
          ) : null}
        </div>
      </>
      <div className="justify-end sm:flex">
        <button
          // disabled
          className="bg-accent  hover:bg-accent-dark rounded-lg py-3 px-8 text-center font-semibold text-white transition-all"
          // className="bg-accent-lighter cursor-default rounded-lg py-3 px-8 text-center font-semibold text-white transition-all"
          onClick={formik.handleSubmit}
        >
          {submitBtnTxt ? submitBtnTxt : "Next"}
        </button>
      </div>
    </div>
  );
};

export default CollectionForm;
